import { render, staticRenderFns } from "./String.vue?vue&type=template&id=472a3ea3&"
import script from "./String.vue?vue&type=script&lang=ts&"
export * from "./String.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports